/**
 * REPORTS DASHBOARD - MAIN CONTAINER
 * Manages report type navigation and layout
 */

import { Component, OnInit, inject } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-reports',
  standalone: true,
  imports: [RouterOutlet],
  template: ` <router-outlet></router-outlet> `,
  styles: [
    `
      :host {
        display: block;
      }
    `,
  ],
})
export class ReportsDashboard implements OnInit {
  private router = inject(Router);

  ngOnInit(): void {
    // Redirect to disbursement by default
    if (this.router.url === '/reports') {
      this.router.navigate(['/reports/disbursement']);
    }
  }
}
